<div class="container">
  <div class="grid-display">
    <div class="title">Drivers</div>
    <div class="driver-reference-grid-actions">
      <div class="search-container {{ loading ? 'loading' : '' }}">
        <search (searchTermChange)="changeSearch($event)" [(searchTerm)]="search"></search>
      </div>
      <action-menu title="Actions" [options]="actionOptions"></action-menu>
      <button class="btn btn-primary add-job" *ngIf="!hasReadOnlyTicketAccess" (click)="onAddDriverClick()">
        {{ 'Add New Driver Reference' | translate }}
      </button>
    </div>
    <ag-grid-angular
      #driversGrid
      class="ag-theme-material drivers-grid"
      [animateRows]="true"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [getRowHeight]="getRowHeight"
      [pagination]="true"
      [rowModelType]="rowModelType"
      [serverSideStoreType]="serverSideStoreType"
      [cacheBlockSize]="cacheBlockSize"
      [maxBlocksInCache]="maxBlocksInCache"
      [frameworkComponents]="frameworkComponents"
      [sideBar]="sideBar"
      [noRowsOverlayComponent]="noRowsOverlayComponent"
      [noRowsOverlayComponentParams]="noRowsOverlayComponentParams"
      (gridReady)="onGridReady($event)"
      (firstDataRendered)="onFirstDataRendered()"
      (filterChanged)="onFilterChanges()"
      rowSelection="multiple"
      suppressBrowserResizeObserver="true"
    ></ag-grid-angular>
  </div>
</div>

